import { ErrorResponse } from '../../../../../store/notifications/actions';
import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { OrderOut, OrderRequestIn } from '../../../../../store/api';
import { confirmCartCheckout } from './apiConfirmCartCheckout';
import { FormDataConfirm } from '../../../../checkout/CheckoutSummary';
import { useHistory } from 'react-router';
import * as types from '../../../../../store/constants';
import { PATH_CART } from '../../../../../store/constants';
import { typedFailure } from '../../../../checkout/utils/request-error';
import { invalidateCartSummaryQuery } from '../../../../../api/shopping-cart/useCartSummaryQuery';

export type CartCheckoutMutationProps = {
    formData: FormDataConfirm;
    meta?: OrderOut;
};

export const useCartCheckout = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    return useMutation<OrderRequestIn, ErrorResponse, CartCheckoutMutationProps>(
        data =>
            confirmCartCheckout(
                mapRequestBody({
                    meta: data.meta,
                    formData: data.formData
                })
            ),
        {
            onSuccess: data => {
                invalidateCartSummaryQuery().then();
                history.push(`${types.PATH_CHECKOUT}/thanks`, data);
            },
            onError: error => {
                dispatch(typedFailure(error, PATH_CART));
            }
        }
    );
};

const mapRequestBody = ({ meta, formData }: CartCheckoutMutationProps): OrderRequestIn => {
    // it is ok to force this type here,
    // because the place order button that triggers this mutation
    // is disabled when the meta request fails.
    const { totalValue, version, id } = meta!;

    return {
        ...formData,
        shoppingCartVersion: version,
        shoppingCartId: id,
        totalValue
    };
};
